// Ngrx
import { createFeatureSelector, createSelector } from '@ngrx/store';

// Models
import { CartHelper, CartItemStatus, cartItemAdapter, CartStatus, Cart } from '../../shared/models/b2b/cart';
import { CartState } from './cart.state';

// Actions
import { CartActions, CartActionTypes } from './cart.actions';

const defaultState: CartState = {
    id: '',
    name: '',
    cart: CartHelper.create(),
    purchasing: false,
    favourite: false,
    msgNewOrder: {},
    status: CartStatus.Initialized,
    timesUpdated: 0,
};

export type Action = CartActions;

// Selectors
export const getCartState = createFeatureSelector<CartState>('cart');

export const getCartItems = createSelector(getCartState, (state: CartState) => state.cart.items);
export const { selectAll: selectCartItems } = cartItemAdapter.getSelectors(getCartItems);

export function CartReducer(state = defaultState, action: any) {
    switch (action.type) {
        case CartActionTypes.DO_PUSH:
            // console.log('ADD ITEM', {state},{action});
            const cartAdd = CartHelper.add(
                state.cart,
                action.payload.item,
                action.payload.quantity,
                CartItemStatus.Validating
            );
            return {
                ...state,
                cart: {
                    ...cartAdd,
                },
            };

        case CartActionTypes.DO_PUSH_MULTIPLE:
            const cartAddMultiple = CartHelper.addMultiple(state.cart, action.payload.items, CartItemStatus.Validating);
            return {
                ...state,
                cart: {
                    ...cartAddMultiple,
                },
            };

        case CartActionTypes.DO_PUSH_OK:
            return state;

        case CartActionTypes.DO_PUSH_KO:
            return state;

        case CartActionTypes.DO_PULL:
            // console.log('REMOVE ITEM', {state},{action});
            const cartRemove = CartHelper.removeItem({ ...state.cart }, { ...action.payload });
            return {
                ...state,
                cart: {
                    ...cartRemove,
                },
            };

        case CartActionTypes.DO_PULL_OK:
            // console.log('REMOVE ITEM OK', {state},{action});
            // if (action.payload.IDPREPEDIDO) {
            //     state.id = action.payload.IDPREPEDIDO;
            // }
            // return pushToCartFromApi(state, action.payload, false);
            return state;

        case CartActionTypes.DO_PULL_KO:
            return state;

        case CartActionTypes.DO_UPDATE:
            // console.log('UPDATE ITEM', {state}, {action});
            let cartUpdate: Cart;
            switch (action.payload.type) {
                case 'quantity':
                    cartUpdate = CartHelper.changeQuantity(
                        { ...state.cart },
                        { ...action.payload.item },
                        action.payload.quantity
                    );
                    break;
                case 'price':
                    cartUpdate = CartHelper.changePrice(
                        { ...state.cart },
                        { ...action.payload.item },
                        action.payload.price
                    );
                    break;
                case 'dto1':
                    cartUpdate = CartHelper.changeDto1(
                        { ...state.cart },
                        { ...action.payload.item },
                        action.payload.discount
                    );
                    break;
                case 'dto2':
                    cartUpdate = CartHelper.changeDto2(
                        { ...state.cart },
                        { ...action.payload.item },
                        action.payload.discount
                    );
                    break;
                case 'shipping':
                    cartUpdate = CartHelper.changeShipping({ ...state.cart }, { ...action.payload.item });
                    break;
                default:
                    break;
            }
            // console.log({cartUpdate});
            return {
                ...state,
                timesUpdated: state.timesUpdated + 1,
                cart: {
                    ...cartUpdate,
                },
            };

        case CartActionTypes.DO_UPDATE_OK:
            // console.log('UPDATE ITEM OK', {state},{action});
            // if (action.payload.IDPREPEDIDO) {
            //     state.id = action.payload.IDPREPEDIDO;
            // }
            // return pushToCartFromApi(state, action.payload, false);
            return state;

        case CartActionTypes.DO_UPDATE_KO:
            return state;

        case CartActionTypes.DO_PURCHASE:
            return {
                ...state,
                purchasing: true,
            };

        case CartActionTypes.DO_PURCHASE_OK:
            return {
                ...state,
                purchasing: false,
                cart: CartHelper.create(),
            };

        case CartActionTypes.DO_PURCHASE_KO:
            return {
                ...state,
                purchasing: false,
            };

        case CartActionTypes.DO_CHANGE_NAME:
            return state;

        case CartActionTypes.DO_CHANGE_NAME_OK:
            return {
                ...state,
                name: action.payload.name,
            };

        case CartActionTypes.DO_CHANGE_NAME_KO:
            return state;

        case CartActionTypes.DO_CLEAR:
            return {
                ...state,
                id: '',
                name: '',
                cnt: 0,
                sum: 0,
                cart: CartHelper.create(),
                purchasing: false,
                favourite: false,
                msgNewOrder: {},
            };

        case CartActionTypes.DO_VALIDATE_CART:
            return {
                ...state,
                status: CartStatus.Validating,
            };

        case CartActionTypes.DO_VALIDATE_CART_OK:
            return {
                ...state,
                cart: action.payload,
                status: CartStatus.Validated,
            };

        case CartActionTypes.DO_VALIDATE_CART_KO:
            const err = action.payload?.error;
            console.error(err);
            return {
                ...state,
                status: CartStatus.Error,
            };

        case CartActionTypes.DO_SET_CART:
            return {
                ...state,
                cart: action.payload.cart,
                status: CartStatus.Validated,
                timesUpdated: state.timesUpdated + 1,
            };

        case CartActionTypes.DO_SET_CART_STATUS:
            return {
                ...state,
                status: action.payload.cartStatus,
            };

        default:
            return state;
    }
}
